
import { requests } from '.'
import { Filter } from '../commons/Types';
import ListData from '../models/List.model';
import Notice from '../models/Notice.model';

export const NoticeApi = {
  list: (filter: Filter) => requests.get<ListData<Notice>>('v1/notice', filter), 
  one: (id: number) => requests.get<Notice>(`v1/notice/${id}`), 
};